module.exports = __webpack_public_path__ + "img/9788925554198.3fb2e1af.jpg";